import { hot } from 'react-hot-loader/root';
import * as React from 'react';
import Routes from './routes/Routes';
import ReactNotification from 'react-notifications-component';
import CookieConsent from 'react-cookie-consent';

import './lib/icons'; // import Font Awesome icon library
import './scss/style.scss'; // import global styles
import 'react-notifications-component/dist/theme.css';
import { config as AppConfig} from './lib/config';
import { Link } from 'react-router-dom';
import { useSelector} from 'react-redux';
import { ApplicationState } from './store';
import { getBrockwaysColourHex } from './lib/methods/getOrderStatusVariant';
import LockScreen from 'react-lock-screen';
import RepLogonPinScreen, { setLockExternal } from '../src/components/RepLogon/RepLogonPinScreen';
import { store } from '.';
import CookieBanner from './components/WholeApp/CookieBanner';
import { encryptAndStoreValueToLocalStorage } from './lib/methods/localStorageBasedMethods';

const documentTitlePrefix = process.env.NODE_ENV === 'development' ? AppConfig.dev.documentTitlePrefix : AppConfig.build.documentTitlePrefix;

const configThemeName: string = process.env.NODE_ENV === 'development' ? AppConfig.dev.theme : AppConfig.build.theme;


const App = () => {

  //used to style cookie banner for different sites
  const setupTheme = useSelector((state: ApplicationState) => state.clientSetup.params?.ThemeOverride);
  // const repLogonLockScreenTimeoutMilSecs = useSelector((state: ApplicationState) => state.clientSetup.params?.RepLogonLockScreenTimeoutMilSecs);
  const repLogonLockScreenTimeoutMilSecs = store.getState().clientSetup.params?.RepLogonLockScreenTimeoutMilSecs;
  const themeCode: string = setupTheme && setupTheme !== '' ? setupTheme : configThemeName;

  //vars for Rep Pin Lock Screen - pull from client app if there else set to 1 minute - likely this is undefiend at this point until the app has been used
  const lockTimeOutMilSecsNoMutate = repLogonLockScreenTimeoutMilSecs ? parseInt(repLogonLockScreenTimeoutMilSecs) : 18000;



  //lock screen on first render - (set to 0) as might be a page refresh
  const [lockTimeOutMilSecs, setLockTimeOutMilSecs] = React.useState(0);
    const oidcFromCentralState = useSelector((state: ApplicationState) => state.oidc);

  //use effect for first render only
  React.useEffect(() => {
    document.title = documentTitlePrefix;
  }, [])

  //#region lock screen callback functions
  //on lock screen or unlock screen, set the timeout back to usual (not 0 - which is only used to control a screen refresh > instant lock if the screen was refreshed from a locked screen state)

  const onScreenLockedCallBack = () => {
    setLockTimeOutMilSecs(lockTimeOutMilSecsNoMutate);
    var result = encryptAndStoreValueToLocalStorage( 'ecomm-screen-lockedEnc', 'true');

  }

  const onScreenUnlockedCallBack = () => {
    setLockTimeOutMilSecs(lockTimeOutMilSecsNoMutate);
    var result = encryptAndStoreValueToLocalStorage('ecomm-screen-lockedEnc', 'false');
  }

  //#endregion
  
  return (

    <>
      {
        //if user settings from identity Server have not been loaded yet...
        ! oidcFromCentralState
          ? <div> Loading... </div>

        //if the user settings from identity server have been loaded and the user is a rep user, enable pin lock mechanism
        : oidcFromCentralState && oidcFromCentralState?.user && oidcFromCentralState?.user?.profile && oidcFromCentralState?.user?.profile?.repUser && oidcFromCentralState?.user?.profile?.repUser.toLowerCase() !== 'false'
          ?

            <LockScreen timeout={lockTimeOutMilSecs} onScreenLocked={onScreenLockedCallBack} onScreenUnlocked={onScreenUnlockedCallBack} ui={(setLock: Function) => <RepLogonPinScreen setLock={setLock} />} >
              <ReactNotification />
              <Routes />
              <CookieBanner/>
            </LockScreen>

        //if the user settings from identity server have been loaded and the user is NOT a rep user, DISABLE pin lock mechanism
        :
          <React.Fragment>
            <ReactNotification />
            <Routes />
            <CookieBanner/>

          </React.Fragment>
      }
    </>
  )
};

export default hot(App);